// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1BDYT","location":"Header_location__1QCKx"};